import React from "react";
import PopupScreen from "../../popup-screen/PopupScreen";

interface CheckoutModalProps {
  modal: boolean;
  cartId: string | null;
  backHome: (data: any) => void;
  onDone: () => void;
  editedAmounts: { [productId: string]: string };
}

const CheckoutModal: React.FC<CheckoutModalProps> = ({ modal, cartId, backHome, onDone, editedAmounts }) => {
  if (!modal) return null;

  return (
    <div className="modal">
      <div className="overlay">
        <div className="modal-content">
          <PopupScreen cartId={cartId} backHome={backHome} onDone={onDone} editedAmounts={editedAmounts} />
        </div>
      </div>
    </div>
  );
};

export default CheckoutModal;
